import { vm, store } from "../socket/config.js";
import { sendMessageToServer } from "../socket/events.js";
import { targetToName } from "../utils/scratch-helpers.js";
import {
    isLocalMode,
    isLocalGlobalFlag,
    setLocalGlobalFlag,
    isLocalStopAll,
    setLocalStopAll,
} from "./local-mode.js";

export const setupMetricsTracking = () => {
    const originalGreenFlag = vm.greenFlag.bind(vm);
    vm.greenFlag = () => {
        if (!isLocalMode() && !isLocalGlobalFlag())
            sendMessageToServer("globalFlagPressed", {});
        if (!isLocalGlobalFlag())
            sendMessageToServer("metric", { action: "green_flag_pressed" });

        setLocalGlobalFlag(false);
        return originalGreenFlag();
    };

    const originalStopAll = vm.stopAll.bind(vm);
    vm.stopAll = function () {
        if (!isLocalMode() && !isLocalStopAll())
            sendMessageToServer("globalStopPressed", {});
        if (!isLocalStopAll())
            sendMessageToServer("metric", { action: "stopAllClicked" });

        setLocalStopAll(false);
        return originalStopAll();
    };

    const originalSetEditingTarget = vm.setEditingTarget.bind(vm);
    vm.setEditingTarget = function (targetId) {
        const target = vm.runtime.getTargetById(targetId);
        if (target && target !== vm.editingTarget) {
            sendMessageToServer("metric", {
                action: "sprite_selected",
                extrargs: { name: targetToName(target) },
            });
        }
        return originalSetEditingTarget(targetId);
    };

    // Fullscreen button tracking
    const attachFullscreenListener = () => {
        const fsBtn = document.querySelector(
            '[class*="button_outlined-button_Uhh7R stage-header_stage-button_32Qds"]',
        );
        if (fsBtn && !fsBtn._metricsTracked) {
            fsBtn._metricsTracked = true;
            fsBtn.addEventListener("click", () => {
                sendMessageToServer("metric", { action: "fullscreen_clicked" });
            });
        }
    };

    const fsObserver = new MutationObserver(attachFullscreenListener);
    fsObserver.observe(document.body, { childList: true, subtree: true });
    attachFullscreenListener();

    // Stage size tracking
    const attachStageListeners = () => {
        const btn = document.querySelector(
            '[class*="toggle-buttons_button_nSjF2"]',
        );
        if (btn && !btn._metricsTracked) {
            btn._metricsTracked = true;
            btn.addEventListener("click", () => {
                sendMessageToServer("metric", { action: "stage_size_clicked" });
            });
        }
    };

    const stageObserver = new MutationObserver(attachStageListeners);
    stageObserver.observe(document.body, { childList: true, subtree: true });
    attachStageListeners();
};
